import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faMinus } from "@fortawesome/pro-light-svg-icons/faMinus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckedState } from "@radix-ui/react-checkbox";
import { forwardRef } from "react";
import { cn } from "../lib/utils";

const Checkbox = forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: "default" | "circular";
  }
>(({ className, variant = "default", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-brand-primary-regular data-[state=checked]:text-system-grayscale-00 data-[state=indeterminate]:bg-brand-primary-regular data-[state=indeterminate]:text-system-grayscale-00 border-brand-primary-regular peer h-[18px] w-[18px] shrink-0 overflow-hidden border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      variant === "circular" ? "rounded-full" : "rounded-sm",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      {variant === "circular" ? (
        <span className="border-brand-primary-regular flex h-4 w-4 items-center justify-center rounded-full border bg-white">
          <span className="bg-brand-primary-regular block h-2 w-2 rounded-full" />
        </span>
      ) : (
        <FontAwesomeIcon
          icon={props.checked === "indeterminate" ? faMinus : faCheck}
          className="h-3 w-3 font-black"
        />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
export type { CheckedState };
